import FormComponent from '../../Form'
import { Stakeholders } from '../../Common'
import labels from '../../Common/translations'

export default {
   fields: {
      accessList: {
         label: labels.fields.computed_access_list,
         type: FormComponent.SELECTMANY,
         disabled: true,
         options: {
            defaultValue: [],
         },
         values: {
            from: 'state',
            prop: 'accessListValues',
            collection: 'roles',
            source: props =>
               Stakeholders(
                  props.authUser.company.ref,
                  [],
                  props.data.accessList,
                  props.authUser.lang
               ),
         },
      },
      defaultAccessList: {
         label: labels.fields.default_access_list,
         type: FormComponent.SELECTMANY,
         mandatory: true,
         options: {
            defaultValue: [],
         },
         values: {
            from: 'state',
            prop: 'defaultAccessListValues',
            collection: 'roles',
            source: props =>
               Stakeholders(
                  props.authUser.company.ref,
                  [],
                  props.data.defaultAccessList,
                  props.authUser.lang
               ),
         },
      },
   },
   buttons: {
      submit: true,
      extras: [],
   },
   actions: {
      update: ({ uid, ...data }) => null,
      redirect: FormComponent.REDIRECT_NONE,
   },
   extras: [],
}
